export default function QuemSomos() {
  return (
    <div id="container" style={{ paddingTop: '10em', paddingLeft: '2em' }}>
      <div id="wb_Text8" style={{ position: 'relative', left: '4px', top: '7px', width: '143px', height: '27px', zIndex: 0, textAlign: 'left' }}>
        <img src="images/mainengine_2015_logo_comprido.jpg" style={{ position: 'relative', left: '4px', width: '692px', height: 'auto', zIndex: 1, textAlign: 'left' }} />
        <h1 className="titulo1">Quem Somos</h1>
        <hr id="Line10" />
        <br />
        <div id="wb_Text9" style={{ position: 'relative', left: '4px', width: '692px', height: '73px', zIndex: 1, textAlign: 'left' }}>
          <div><span className="linha_texto">A MainEngine é uma empresa de <b>Consultoria em Soluções de Sistemas</b> que iniciou suas operações em 1998; </span></div>
          <div><span className="linha_texto">Atendendo de forma especializada o mercado de <b>Entidades Associativas</b>, principalmente as vinculadas a <b>SUSEP</b> (<b>Previdência e Seguradoras</b>).</span></div>
        </div>
      </div>    
    </div>
  )
}
